<div class="truck-registration-masterdata">
    <sc-padding>
        <sc-flex vertical fitHeight stretchContent>
            <sc-content-spacer vertical grow></sc-content-spacer>
            <ng-container [formGroup]="masterdataForm">

                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.numberplate"></sc-dictionary-label>
                  </mat-label>
                    <input matInput name="numberplate" formControlName="numberplate"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.carrier"></sc-dictionary-label>
                  </mat-label>
                    <input matInput name="carrier" formControlName="carrier"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.supplier"></sc-dictionary-label>
                  </mat-label>
                    <input matInput name="supplier" formControlName="supplier"
                        [required]="false" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.driver"></sc-dictionary-label>
                  </mat-label>
                    <input matInput name="driver" formControlName="driver"
                        [required]="true" minlength="row.minLength" maxlength="255">
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.co-driver"></sc-dictionary-label>
                  </mat-label>
                    <input matInput name="coDriver" formControlName="coDriver"
                        [required]="false" minlength="row.minLength" maxlength="255">
                </mat-form-field>

            </ng-container>
            <sc-content-spacer vertical grow></sc-content-spacer>
        </sc-flex>
    </sc-padding>
</div>
